<template>
  <v-container>
    <div class="d-flex flex-column">
      <fieldset>
        <!-- --------------- -->
        <!-- Infos livraison  -->
        <!-- ---------------- -->

        <legend>
          <div class="text-body-1 font-weight-bold pt-5">Informations de livraison</div>
        </legend>
        <v-divider />

        <v-layout
          v-if="
            this.$store.getters.commande.destinataireClient.noClientJDE != null
          "
        >
          <v-flex xs10>
            <div class="text-body-2 font-weight-bold pl-5 pt-2 mb-4">{{ texteSansInstruction }}</div>
          </v-flex>
        </v-layout>

        <v-row class="pl-3 pt-2">
          <v-col cols="6" sm="3" class="pa-0 pl-5 pt-3">Type de livraison</v-col>
          <v-col cols="6" sm="3" class="pa-0">
            <v-select
              v-model.trim="typeLivraison"
              :items="listeLivraison"
              label="Sélectionnez"
              item-text="1"
              item-value="0"
              class="text-caption pa-0"
              dense
              height="40"
              single-line
              hide-no-data
              @change="majTypeLivraison()"
            />
          </v-col>
        </v-row>

        <v-row v-if="afficherNomSuccursale && !afficherListeSuccursale" class="pl-3">
          <v-col cols="6" sm="3" class="pa-0 pl-5 pt-7">Succursale de livraison</v-col>
          <v-col cols="6" sm="3" class="pa-0 mt-3 pt-5">{{ nomSuccursale }}</v-col>
        </v-row>

        <v-row v-if="afficherListeSuccursale" class="pl-3">
          <v-col cols="6" sm="3" class="pa-0 pl-5 pt-7">Succursale de livraison</v-col>
          <v-col cols="6" sm="3" class="pa-0 pt-6">
            <v-autocomplete
              v-model.trim="succursale"
              :items="succursales"
              item-value="code"
              :item-text="item => item.code + ' - ' + item.nom"
              class="text-caption pa-0 ma-0"
              label="Succursales de livraison"
              dense
              single-line
              hide-no-data
              @change="majSuccursaleLivraison()"
            />
          </v-col>
        </v-row>

        <v-row v-if="dateLivraisonEstimee != null" class="pl-3">
          <v-col cols="6" sm="3" class="pa-0 pl-5 pt-5">Date de livraison</v-col>
          <v-col cols="6" sm="3" class="pa-0 mt-3 pt-3">{{ dateLivraisonEstimee.dateLivraison }}</v-col>
        </v-row>

        <v-layout v-if="journeeLivraison != null && typeLivraison != 'SERVICE_AUTO'" pl-5 pt-6>
          <v-flex xs3>Journée de livraison</v-flex>
          <v-flex xs6 pb-6>{{ journeesLivraison.get(journeeLivraison) }}</v-flex>
        </v-layout>

        <v-layout
          v-if="
            typeLivraison == 'LIVRAISON_ETABLISSEMENT' &&
              this.$store.getters.commande.commandeExcel == false
          "
          pl-5
        >
          <v-flex
            v-if="this.$store.getters.commande.commandeAgent == false"
            xs3
            pt-3
            pb-5
          >Commande payée par l'agent</v-flex>

          <v-checkbox
            v-if="
              this.$store.getters.commande.commandeExcel == false &&
                this.$store.getters.commande.commandeAgent == false
            "
            v-model="commande.indPayeParAgent"
            class="mt-1"
          />
        </v-layout>

        <template v-if="commande.indPayeParAgent && typeLivraison != 'SERVICE_AUTO'">
          <v-layout>
            <v-flex class="font-weight-bold" xs6 pl-5>
              Si vous avez plusieurs carte à votre dossier, veuillez spécifier
              la carte à utiliser
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs3 pt-3 pl-5>Type de carte de crédit</v-flex>
            <v-flex xs3>
              <v-select
                v-model.trim="commande.typeCarte"
                :items="typesCarteCredit"
                label="Sélectionnez"
                item-text="1"
                item-value="0"
                class="text-caption pa-0 ml-2 ma-0 mb-4"
                dense
                height="40"
                clearable
                single-line
                hide-no-data
              />
            </v-flex>
          </v-layout>

          <v-layout pt-5>
            <v-flex xs3 pl-5 pt-3>4 derniers chiffres de la carte de crédit</v-flex>
            <v-flex xs1 pb-6>
              <v-text-field v-model.trim="commande.dernierChiffreCarte" solo dense maxlength="4" />
            </v-flex>
          </v-layout>
        </template>

        <!-- -------- -->
        <!-- Commande -->
        <!-- -------- -->

        <legend>
          <div class="text-body-1 font-weight-bold pt-8">Commande</div>
        </legend>
        <v-divider />

        <v-row class="pl-3 pt-5">
          <v-col
            cols="6"
            sm="3"
            class="pa-0 pl-5 pt-5"
          >Rechercher par code ou description de produit</v-col>
          <v-col cols="6" sm="5" class="pa-0 pl-5 pt-3">
            <v-autocomplete
              v-model="produitSelect"
              :items="items"
              :loading="loading"
              :search-input.sync="recherche"
              hide-no-data
              hide-selected
              item-color="blue"
              dense
              item-text="infoProduit"
              label="Sélectionnez"
              return-object
              @change="ajouterProduit"
            />
          </v-col>
        </v-row>

        <v-layout>
          <v-flex xs3 pt-5 pl-5>
            <v-text-field
              v-model.trim="produit"
              append-icon="search"
              clearable
              solo
              dense
              maxlength="10"
              @keyup.enter="ajouterProduit(produit)"
            >
              <template v-slot:label>
                <div style="font-size: 12px;">Veuillez saisir le code produit</div>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs11 class="pt-2">
            <v-col mt-6>
              <v-data-table
                :headers="headers"
                :items="produits"
                dense
                :loading="loading"
                no-data-text="Aucun produit dans cette commande"
                :hide-default-footer="true"
                disable-pagination
              >
                <template v-slot:item.noProduit="{ item }">
                  <span style="font-size: 12px;">{{ item.noProduit }}</span>
                </template>

                <template v-slot:item.descriptionProduit="{ item }">
                  <span style="font-size: 12px;">
                    {{
                    item.descriptionProduit
                    }}
                  </span>
                </template>

                <template v-slot:item.millesime="{ item }">
                  <span style="font-size: 12px;">{{ item.millesime }}</span>
                </template>

                <template v-slot:item.formatMl="{ item }">
                  <span style="font-size: 12px;">{{ item.formatMl }}</span>
                </template>

                <template v-slot:item.uvc="{ item }">
                  <span style="font-size: 12px;">{{ item.uvc }}</span>
                </template>

                <template v-slot:item.quantite="{ item }">
                  <v-text-field
                    v-model="item.quantite"
                    maxlength="5"
                    style="width:60px;height:40px"
                    solo
                    dense
                  />
                </template>

                <!--
                <template v-slot:item.quantiteInventaire="{ item }">
                  <div
                    v-if="
                      Number(item.quantiteInventaire) < Number(item.quantite)
                    "
                    class="messageErreur"
                  >
                    La quantité commandée est supérieure à la quantité
                    disponible.
                  </div>
                  <div
                    v-if="
                      Number(item.quantiteInventaire) < Number(item.quantite) &&
                        Number(item.quantiteInventaire) < Number(0)
                    "
                    class="messageErreur"
                  >
                    Inventaire disponible: 0 bouteilles
                  </div>
                  <div
                    v-if="
                      Number(item.quantiteInventaire) < Number(item.quantite) &&
                        Number(item.quantiteInventaire) >= Number(0)
                    "
                    class="messageErreur"
                  >
                    Inventaire disponible:
                    {{ item.quantiteInventaire }} bouteilles
                  </div>
                </template>
                -->

                <template v-slot:item.quantiteInventaire="{ item }">
                  <div
                    v-if="
                      item.quantiteInventaire != null &&
                        Number(item.quantiteInventaire) < Number(item.quantite)
                    "
                    class="messageErreur"
                  >
                    La quantité commandée est supérieure à la quantité
                    disponible.
                  </div>
                  <div
                    v-if="
                      item.quantiteInventaire != null &&
                        Number(item.quantiteInventaire) <
                          Number(item.quantite) &&
                        Number(item.quantiteInventaire) < Number(0)
                    "
                    class="messageErreur"
                  >Inventaire disponible: 0 bouteilles</div>
                  <div
                    v-if="
                      item.quantiteInventaire != null &&
                        Number(item.quantiteInventaire) <
                          Number(item.quantite) &&
                        Number(item.quantiteInventaire) >= Number(0)
                    "
                    class="messageErreur"
                  >
                    Inventaire disponible:
                    {{ item.quantiteInventaire }} bouteilles
                  </div>

                  <div v-else-if="item.indQuantiteInvalideUVC == true" class="messageErreur">
                    La quantité commandée doit correspondre à une caisse
                    complète selon l'unité de vente.
                  </div>

                  <div
                    v-else-if="item.indQuantiteRestanteModulo == true"
                    class="messageAvertissement"
                  >
                    L'inventaire de votre produit contient une caisse incomplète
                    de {{ item.quantiteModulo }} bouteille(s). Veuillez modifier
                    la quantité ou commander la caisse partielle à votre
                    prochaine commande.
                  </div>

                  <div
                    v-else-if="item.indQuantiteEtInventaireSousUVC == true"
                    class="messageErreur"
                  >
                    La quantité totale de l'inventaire doit être commandée.
                    <br />
                    Inventaire {{ item.quantiteModulo }} bouteille(s).
                  </div>
                </template>

                <template v-slot:item.action="{ item }" class="d-flex justify-center">
                  <v-icon medium color="pink" @click="supprimerProduit(item)">delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-flex>
        </v-layout>
      </fieldset>
    </div>
  </v-container>
</template>

<script>
class Post {
  constructor(title, link, author) {
    this.title = title
    this.link = link
    this.author = author
  }
}

import {
  journeesLivraison,
  typesCarteCredit,
  typesLivraison,
} from '@/plugins/enums'
import moment from 'moment'
export default {
  name: 'StepCommande',
  data() {
    return {
      produit: null,
      produitSelect: null,
      produitParCode: null,
      inventaireIP: [],
      loading: false,
      produitRecherche: [],
      recherche: null,
      typeLivraison: null,
      listeLivraison: [],
      texteSansInstruction: null,
      nomSuccursale: null,
      afficherNomSuccursale: false,
      codeSuccursale: null,
      succursaleRecherche: {},
      journeeLivraison: null,
      afficherListeSuccursale: false,
      succursale: {},
      succursales: [],
      succursalesParticulier: [],
      listeProduitQuantiteInsuffisante: [],
      dateLivraisonEstimee: null,

      headers: [
        { text: 'Code article', value: 'noProduit' },
        { text: 'Description', value: 'descriptionProduit', width: '200px' },
        {
          text: '',
          value: 'quantiteInventaire',
          sortable: false,
          align: 'left',
          width: '250px',
        },
        { text: 'Qté btls', value: 'quantite' },
        {
          text: 'Millésime',
          align: 'center',
          value: 'millesime',
        },
        { text: 'Format', align: 'center', value: 'formatMl' },
        { text: 'uvc', align: 'center', value: 'uvc' },
        { text: 'Supprimer', value: 'action', align: 'center' },
      ],
      headersRecherche: [
        { text: 'CODE ARTICLE', value: 'noProduit' },
        { text: 'DESCRIPTION', value: 'descriptionProduit' },
        { text: 'MILLESIME', value: 'millesime' },
        { text: 'FORMAT', value: 'formatMl' },
        { text: 'UVC', value: 'uvc' },
        { text: 'PRIX', value: 'prixDetail' },
      ],
      footerProps: {
        itemsPerPageOptions: [2],
        itemsPerPageText: 'Produits par page',
      },
      commandeFichierExcel: { lignes: [] },
      defaultSelected: {},
    }
  },
  computed: {
    commande: function () {
      return this.$store.getters.commande
    },
    agentConnecte: function () {
      return this.$store.getters.agentConnecte
    },
    commandeAgent: function () {
      return this.$store.getters.commandeAgent
    },
    produits: function () {
      return this.$store.getters.commande.produits
    },
    typesLivraison: function () {
      return Array.from(typesLivraison)
    },
    typesLivraisonTest: function () {
      return typesLivraison
    },
    journeesLivraison: function () {
      return journeesLivraison
    },
    typesCarteCredit: function () {
      return Array.from(typesCarteCredit)
    },

    items() {
      return this.produitRecherche.map((p) => {
        const infoProduit =
          p.noProduit +
          ' ' +
          p.descriptionProduit +
          ' ' +
          p.millesime +
          ' ' +
          p.formatMl +
          'ml ' +
          p.uvc +
          ' ' +
          p.prixDetail.toFixed(2) +
          ' $'
        return Object.assign({}, p, { infoProduit })
      })
    },
  },

  watch: {
    recherche(val) {
      if (val == null || val == '') {
        this.produitRecherche = []
      } else {
        this.produitRecherche = this.inventaireIP
      }
    },

    '$store.getters.commande.typeLivraison': function (typeLivraison) {
      console.log('Dans le watch du type de livraison ' + typeLivraison)

      if (this.commande.typeLivraison != 'LIVRAISON_SUCCURSALE') {
        this.afficherNomSuccursale = false
      }

      if (
        this.commandeAgent &&
        this.commande.typeLivraison == 'LIVRAISON_SUCCURSALE' &&
        this.commande.succursaleLivraisonDemande == null
      ) {
        console.log('Commande pour un agent lui-meme  ')
      } else {
        if (
          typeLivraison == null &&
          this.$store.getters.commande.typeLivraison == null
        ) {
          this.succursale = null
          this.afficherNomSuccursale = false
          this.afficherListeSuccursale = false
          this.typeLivraison = null
          this.journeeLivraison = null
          this.listeLivraison = []
          this.dateLivraisonEstimee = null

          for (let i = 0; i < this.typesLivraison.length; i++) {
            if (this.typesLivraison[i][0] === 'SERVICE_AUTO') {
              this.listeLivraison.push(this.typesLivraison[i])
            }
          }
        }

        if (this.typeLivraison != null) {
          this.dateLivraisonEstimee = this.obtenirDateLivraisonEstimee(
            this.typeLivraison
          )
        }
      }
    },

    // On construit l'instruction de livraison en fonction du demandeur: Agent ou Client
    '$store.getters.commande.destinataireClient': function (
      destinataireClient
    ) {
      console.log('Dans le watch de commande - destinataireClient')

      // Aucun destinataire associe a la commande: On a decocher la checkbox "pour lui meme"
      if (!destinataireClient) {
        this.typeLivraison = null
        return
      }

      this.listeLivraison = []

      if (this.commandeAgent) {
        console.log('step commande : commande fait pour agent lui-même')

        // Commande pour agent
        this.texteSansInstruction = null
        this.typeLivraison = null
        this.commande.nomClient = this.$store.getters.agentConnecteInfosJDE.nom
        this.$store.getters.commande.demandeur =
          this.$store.getters.agentConnecte
        this.$store.getters.commande.destinataireClient.isAgent = true
        this.$store.getters.commande.destinataireClient.isClient = false
        this.$store.getters.commande.destinataireClient.nomContact =
          this.$store.getters.commande.demandeur.nomContact
        this.$store.getters.commande.destinataireClient.courrielContact =
          this.$store.getters.commande.demandeur.courrielContact

        this.$store.getters.commande.destinataireClient.typeClient =
          'AGENT_PROMOTIONNEL'

        if (
          this.$store.getters.commande.destinataireClient
            .instructionLivraisonIPData != null
        ) {
          const instructionLivraison =
            this.$store.getters.commande.destinataireClient
              .instructionLivraisonIPData

          // l'agent à une instruction de livraison
          console.log('L agent a une instruction de livraison')

          for (let i = 0; i < this.typesLivraison.length; i++) {
            if (
              instructionLivraison.typeLivraison === this.typesLivraison[i][0]
            ) {
              this.listeLivraison.push(this.typesLivraison[i])
              // break
            }
            // On ajoute toujours en plus service à l'auto car par défaut
            if (
              this.typesLivraison[i][0] === 'SERVICE_AUTO' ||
              this.typesLivraison[i][0] === 'LIVRAISON_SUCCURSALE'
            ) {
              this.listeLivraison.push(this.typesLivraison[i])
            }
          }
        } else {
          // l'agent n'a pas d'instruction de livraison
          console.log("L'agent n'a pas d'instruction de livraison")

          for (let i = 0; i < this.typesLivraison.length; i++) {
            if (
              this.typesLivraison[i][0] === 'SERVICE_AUTO' ||
              this.typesLivraison[i][0] === 'LIVRAISON_SUCCURSALE'
            ) {
              this.listeLivraison.push(this.typesLivraison[i])
            }
          }

          this.succursales = this.succursalesParticulier
          this.texteSansInstruction = null
          this.afficherNomSuccursale = false
        }
      } else {
        console.log('step commande : commande pour un client ')
        // Commande pour Client

        if (
          this.$store.getters.commande.destinataireClient.noClientJDE != null ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'PART_USAGE_PERSONNEL' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'LIEU_DE_CULTE'
        ) {
          this.afficherListeSuccursale = false

          this.$store.getters.commande.destinataireClient.isAgent = false
          this.$store.getters.commande.destinataireClient.isClient = true

          // Commande existante en brouillon ou copié
          if (this.$store.getters.commande.noCommande != null) {
            console.log('Provient de copier/transmettre la commande')

            if (
              this.$store.getters.commande.destinataireClient
                .instructionLivraisonIPData != null
            ) {
              this.texteSansInstruction = null
              console.log('Le client a une instruction de livraison')

              if (
                this.$store.getters.commande.destinataireClient.typeClient !=
                'AGENT_PROMOTIONNEL'
              ) {
                if (
                  this.commande.typeLivraison == 'LIVRAISON_ETABLISSEMENT' &&
                  this.$store.getters.commande.destinataireClient
                    .instructionLivraisonIPData.typeLivraison ==
                    'LIVRAISON_SUCCURSALE'
                ) {
                  console.log(
                    'La commande copié a livraison etablissement mais l instruction est succursale'
                  )
                  this.commande.typeLivraison = 'LIVRAISON_SUCCURSALE'
                  this.$store.getters.commande.succursaleLivraisonDemande =
                    this.$store.getters.commande.destinataireClient.instructionLivraisonIPData.codeSuccursale
                }
              }

              this.typeLivraison = this.commande.typeLivraison

              if (
                this.$store.getters.commande.destinataireClient.typeClient !=
                'AGENT_PROMOTIONNEL'
              ) {
                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (
                    this.$store.getters.commande.destinataireClient
                      .instructionLivraisonIPData.typeLivraison ===
                    this.typesLivraison[i][0]
                  ) {
                    this.listeLivraison.push(this.typesLivraison[i])
                    break
                  }
                  if (this.typesLivraison[i][0] === 'SERVICE_AUTO') {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }
              } else {
                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (
                    this.$store.getters.commande.destinataireClient
                      .instructionLivraisonIPData.typeLivraison ===
                    this.typesLivraison[i][0]
                  ) {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                  if (
                    this.typesLivraison[i][0] === 'SERVICE_AUTO' ||
                    this.typesLivraison[i][0] === 'LIVRAISON_SUCCURSALE'
                  ) {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }
              }

              if (this.commande.typeLivraison == 'LIVRAISON_SUCCURSALE') {
                this.afficherListeSuccursale = false
                this.obtenirSuccursale(
                  this.$store.getters.commande.succursaleLivraisonDemande
                )
                this.afficherNomSuccursale = true
              }

              this.dateLivraisonEstimee = this.obtenirDateLivraisonEstimee(
                this.commande.typeLivraison
              )
            } else {
              console.log('Le client est sans instruction de livraison')

              this.texteSansInstruction = null
              this.afficherNomSuccursale = false
              this.nomSuccursale = null

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                'TITULAIRE_POUR_REVENTE'
              ) {
                this.texteSansInstruction =
                  "Ce client ne détient pas de modalité de livraison, l''option « service à l''auto » est cependant disponible. Si votre client souhaite ajouter une modalité de livraison il devra contacter notre service à la clientèle au (514) 254-8686 option 4."

                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (this.typesLivraison[i][0] === 'SERVICE_AUTO') {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }

                // Le destinataire est un particulier ou lieu de culte
              } else if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'PART_USAGE_PERSONNEL' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'LIEU_DE_CULTE' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'AGENT_PROMOTIONNEL'
              ) {
                console.log(
                  'Le client est un particulier ,  lieu de culte ou agent'
                )

                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (
                    this.typesLivraison[i][0] === 'SERVICE_AUTO' ||
                    this.typesLivraison[i][0] === 'LIVRAISON_SUCCURSALE'
                  ) {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }
                this.succursales = this.succursalesParticulier
                if (this.typeLivraison == 'LIVRAISON_SUCCURSALE') {
                  this.afficherListeSuccursale = true
                }
              }
            }
          } else {
            // Nouvelle commande

            console.log(
              'Nouvelle commande ' +
                this.$store.getters.commande.destinataireClient.typeClient
            )

            if (
              this.$store.getters.commande.destinataireClient
                .instructionLivraisonIPData != null &&
              this.$store.getters.commande.destinataireClient
                .instructionLivraisonIPData.dtInactivite == null
            ) {
              this.texteSansInstruction = null
              // le client à une instruction de livraison
              console.log('Le client a une instruction de livraison')

              const instructionLivraison =
                this.$store.getters.commande.destinataireClient
                  .instructionLivraisonIPData

              for (let i = 0; i < this.typesLivraison.length; i++) {
                if (
                  instructionLivraison.typeLivraison ===
                  this.typesLivraison[i][0]
                ) {
                  this.listeLivraison.push(this.typesLivraison[i])
                  break
                }

                // On ajoute toujours en plus service à l'auto car par défaut
                if (this.typesLivraison[i][0] === 'SERVICE_AUTO') {
                  this.listeLivraison.push(this.typesLivraison[i])
                }
              }
            } else {
              console.log('Le client est sans instruction de livraison')

              // Le destinataire est un TP mais sans instruction de livraison

              this.texteSansInstruction = null
              this.afficherNomSuccursale = false
              this.nomSuccursale = null

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                'TITULAIRE_POUR_REVENTE'
              ) {
                this.texteSansInstruction =
                  "Ce client ne détient pas de modalité de livraison, l''option « service à l''auto » est cependant disponible. Si votre client souhaite ajouter une modalité de livraison il devra contacter notre service à la clientèle au (514) 254-8686 option 4."

                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (this.typesLivraison[i][0] === 'SERVICE_AUTO') {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }

                // Le destinataire est un particulier ou lieu de culte
              } else if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'PART_USAGE_PERSONNEL' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'LIEU_DE_CULTE' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'AGENT_PROMOTIONNEL'
              ) {
                console.log(
                  'Le client est un particulier ,  lieu de culte ou agent'
                )

                for (let i = 0; i < this.typesLivraison.length; i++) {
                  if (
                    this.typesLivraison[i][0] === 'SERVICE_AUTO' ||
                    this.typesLivraison[i][0] === 'LIVRAISON_SUCCURSALE'
                  ) {
                    this.listeLivraison.push(this.typesLivraison[i])
                  }
                }
              }
            }

            if (this.$store.getters.commande.commandeExcel == true) {
              console.log(
                'La commande vient de Excel on set le type de livraison'
              )
              this.typeLivraison = this.$store.getters.commande.typeLivraison
              this.majInfosLivraisonDeExcel()
            }
          }
          this.commande.nomClient = null
        }
      }
    },
  },

  beforeMount() {
    console.log('Dans le beforeMount de step - commande')
    axios
      .get(`/commandesip/${this.agentConnecte.idDemandeur}`)
      .then((response) => {
        let resp = response.data
        switch (resp.codeRetour) {
          case 'OK':
            this.inventaireIP = resp.resultat.produits
            this.lireSuccursales()
            this.lireSuccursalesParticulier()

            break
          default:
            console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
            this.$store.dispatch(
              'afficherError',
              `Une erreur technique est survenue (${resp.codeRetour}  )`
            )
            break
        }
      })
      .catch((error) => {
        console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })
  },

  methods: {
    obtenirDateLivraisonEstimee(typeLivraison) {
      console.log(
        'obtenirDateLivraisonEstimee pour ' +
          this.$store.getters.commande.destinataireClient.idDemandeur +
          ' type de livraison ' +
          typeLivraison
      )

      if (typeLivraison == 'SERVICE_AUTO') {
        if (
          this.$store.getters.commande.destinataireClient.idDemandeur == null
        ) {
          console.log(
            'Le destinataire est un nouveau client pour passer le service auto on mets a 0 son idDemandeur'
          )
          this.$store.getters.commande.destinataireClient.idDemandeur = 0
        }

        axios
          .get(
            `/calendrier/estimer/auto/${
              this.$store.getters.commande.destinataireClient.idDemandeur
            }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
          )
          .then((response) => {
            let resp = response.data
            switch (resp.codeRetour) {
              case 'OK':
                this.dateLivraisonEstimee = resp.resultat
                console.log(
                  'Resultat de la date extimee ' +
                    this.dateLivraisonEstimee.dateLivraison
                )

                break
              default:
                console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                this.$store.dispatch(
                  'afficherError',
                  `Une erreur technique est survenue (${resp.codeRetour}  )`
                )
                break
            }
          })
          .catch((error) => {
            console.log('error=' + error)
            let texte = ''
            if (error.response) {
              texte = `Status: ${error.response.status} Data: ${error.response.data}`
              console.log(texte)
            } else {
              texte = `Une erreur technique est survenue: ${error.message}`
            }
            this.$store.dispatch('afficherError', texte)
          })
      } else {
        if (
          this.$store.getters.commande.destinataireClient
            .instructionLivraisonIPData != null
        ) {
          axios
            .get(
              `/calendrier/estimer/ip/${
                this.$store.getters.commande.destinataireClient.idDemandeur
              }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
            )
            .then((response) => {
              let resp = response.data
              switch (resp.codeRetour) {
                case 'OK':
                  this.dateLivraisonEstimee = resp.resultat
                  console.log(
                    'Resultat de la date extimee ' +
                      this.dateLivraisonEstimee.dateLivraison
                  )

                  break
                default:
                  console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                  this.$store.dispatch(
                    'afficherError',
                    `Une erreur technique est survenue (${resp.codeRetour}  )`
                  )
                  break
              }
            })
            .catch((error) => {
              console.log('error=' + error)
              let texte = ''
              if (error.response) {
                texte = `Status: ${error.response.status} Data: ${error.response.data}`
                console.log(texte)
              } else {
                texte = `Une erreur technique est survenue: ${error.message}`
              }
              this.$store.dispatch('afficherError', texte)
            })
        }
      }
    },

    ajouterProduit(produit) {
      let noProduit
      if (typeof produit === 'object') {
        noProduit = produit.noProduit
      } else {
        noProduit = produit
      }

      console.log('ajouterProduit: ' + noProduit)

      let trouve = new Boolean(false)
      for (let i = 0; i < this.produits.length; i++) {
        if (this.produits[i].noProduit === Number(noProduit)) {
          this.$store.dispatch('afficherError', {
            texte: 'Ce produit est déja dans la liste des produits',
            duree: 5,
          })
          return
        }
      }

      for (let i = 0; i < this.inventaireIP.length; i++) {
        if (
          this.inventaireIP[i].noProduit.toString() === noProduit.toString()
        ) {
          trouve = true
          let p = this.inventaireIP[i]
          p.quantite = this.inventaireIP[i].uvc
          this.$store.dispatch('ajouterProduit', p)

          // Pour remettre à blanc le select
          this.$nextTick(() => {
            this.produitSelect = null
          })
        }
      }
      this.produit = null
      if (trouve == false) {
        this.$store.dispatch('afficherError', {
          texte: "Ce produit n''existe pas dans votre inventaire",
          duree: 5,
        })
      }
    },

    supprimerProduit(item) {
      console.log('supprimerProduit ' + item.noProduit)
      item.quantiteInventaire = null
      item.quantite = null

      for (let i = 0; i < this.$store.getters.commande.produits.length; i++) {
        item.indMessageQuantiteCaisseAffiche = false
        item.indQuantiteEtInventaireSousUVC = false
        item.indQuantiteInvalideUVC = false
        item.indQuantiteRestanteModulo = false
      }

      this.$store.dispatch('supprimerProduit', item)
    },

    majSuccursaleLivraison() {
      console.log(
        'majSuccursaleLivraison ' +
          this.$store.getters.commande.destinataireClient.typeClient
      )

      if (this.succursale != null) {
        this.$store.getters.commande.succursaleLivraisonDemande =
          this.succursale

        //Pour le client particulier on va calculer  la date de livraison estimé selon la succursale sélectionné
        if (
          this.$store.getters.commande.destinataireClient.typeClient ==
            'PART_USAGE_PERSONNEL' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'LIEU_DE_CULTE' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'AGENT_PROMOTIONNEL'
        ) {
          axios
            .get(
              `/calendrier/estimer/ip/succursale/${
                this.succursale
              }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
            )
            .then((response) => {
              let resp = response.data
              switch (resp.codeRetour) {
                case 'OK':
                  this.dateLivraisonEstimee = resp.resultat
                  console.log(
                    'Resultat de la date extimee ' +
                      this.dateLivraisonEstimee.dateLivraison
                  )

                  break
                default:
                  console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                  this.$store.dispatch(
                    'afficherError',
                    `Une erreur technique est survenue (${resp.codeRetour}  )`
                  )
                  break
              }
            })
            .catch((error) => {
              console.log('error=' + error)
              let texte = ''
              if (error.response) {
                texte = `Status: ${error.response.status} Data: ${error.response.data}`
                console.log(texte)
              } else {
                texte = `Une erreur technique est survenue: ${error.message}`
              }
              this.$store.dispatch('afficherError', texte)
            })
        }
      }
    },

    majTypeLivraison() {
      console.log('majTypeLivraison ' + this.typeLivraison)

      this.$store.getters.commande.typeLivraison = this.typeLivraison

      if (
        this.$store.getters.commande.destinataireClient
          .instructionLivraisonIPData != null &&
        this.$store.getters.commande.destinataireClient.typeClient !=
          'AGENT_PROMOTIONNEL'
      ) {
        if (this.typeLivraison === 'LIVRAISON_SUCCURSALE') {
          this.obtenirSuccursale(
            this.$store.getters.commande.destinataireClient
              .instructionLivraisonIPData.codeSuccursale
          )

          this.$store.getters.commande.succursaleLivraisonDemande =
            this.commande.destinataireClient.instructionLivraisonIPData.codeSuccursale

          this.afficherListeSuccursale = false
          this.afficherNomSuccursale = true
        } else if (this.typeLivraison === 'SERVICE_AUTO') {
          this.afficherListeSuccursale = false
          this.afficherNomSuccursale = false
          this.nomSuccursale = null
        } else if (this.typeLivraison === 'LIVRAISON_ETABLISSEMENT') {
          this.afficherListeSuccursale = false
          this.afficherNomSuccursale = false
          this.journeeLivraison =
            this.$store.getters.commande.destinataireClient.instructionLivraisonIPData.journeeLivraison
        }
      } else {
        if (this.typeLivraison === 'LIVRAISON_SUCCURSALE') {
          this.afficherListeSuccursale = true

          // Commande pour agent lui-même
          if (this.commandeAgent) {
            console.log('Commande pour agent lui meme ')
            if (this.typeLivraison === 'LIVRAISON_SUCCURSALE') {
              this.afficherListeSuccursale = true
            } else {
              this.afficherListeSuccursale = false
            }
          }

          if (
            this.$store.getters.commande.destinataireClient.typeClient ==
              'PART_USAGE_PERSONNEL' ||
            this.$store.getters.commande.destinataireClient.typeClient ==
              'LIEU_DE_CULTE'
          ) {
            this.succursale = null
            this.succursales = this.succursalesParticulier
          }
        } else {
          this.afficherListeSuccursale = false
        }
      }

      //this.journeeLivraison = null
      this.texteSansInstruction = null
    },

    obtenirSuccursale(code) {
      console.log('obtenirSuccursale ' + code)

      if (code != undefined) {
        this.loading = true
        axios
          .get(`/succursales/${code}`)
          .then((response) => {
            let resp = response.data
            let msg = null
            switch (resp.codeRetour) {
              case 'OK':
                this.succursaleRecherche = resp.resultat
                this.nomSuccursale =
                  this.succursaleRecherche.code +
                  ' - ' +
                  this.succursaleRecherche.nom
                break
              case 'W001':
                this.succursaleRecherche = []
                this.$store.dispatch(
                  'afficherInfo',
                  "Il n'existe aucune succursale pour ce code"
                )
                break
              default:
                msg = this.$fmtApiErr(resp)
                console.log(msg)
                this.$store.dispatch('afficherError', msg)
                break
            }
          })
          .catch((error) => {
            this.succursales = []
            console.log('error=' + error)
            let msg = this.$fmtAxiosErr(error)
            this.$store.dispatch('afficherError', msg)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    majInfosLivraisonDeExcel() {
      console.log(
        'COMMANDE DE FICHIER EXCEL ',
        this.$store.getters.commande.typeLivraison +
          '  ' +
          this.$store.getters.commande.destinataireClient.typeClient
      )

      if (
        this.$store.getters.commande.destinataireClient
          .instructionLivraisonIPData == null
      ) {
        console.log('Le client est sans instruction de livraison ')

        if (
          this.$store.getters.commande.destinataireClient.typeClient ==
            'PART_USAGE_PERSONNEL' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'LIEU_DE_CULTE' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'AGENT_PROMOTIONNEL'
        ) {
          this.succursale = null
          this.succursales = this.succursalesParticulier
        }

        if (
          this.$store.getters.commande.destinataireClient.typeClient ==
          'TITULAIRE_POUR_REVENTE'
        ) {
          console.log(
            'Le client est sans instruction de livraison et titulaire '
          )

          this.typeLivraison = 'SERVICE_AUTO'
          this.afficherListeSuccursale = false
          this.afficherNomSuccursale = false

          this.texteSansInstruction =
            "Ce client ne détient pas de modalité de livraison, l''option « service à l''auto » est cependant disponible. Si votre client souhaite ajouter une modalité de livraison il devra contacter notre service à la clientèle au (514) 254-8686 option 4."
        }
      }

      if (
        this.$store.getters.commande.destinataireClient
          .instructionLivraisonIPData != null
      ) {
        if (
          this.typeLivraison != 'SERVICE_AUTO' &&
          this.$store.getters.commande.destinataireClient
            .instructionLivraisonIPData.typeLivraison != this.typeLivraison
        ) {
          this.$store.dispatch(
            'afficherInfo',
            "Le type de livraison dans l'instruction du client, diffère de celle indiqué dans la commande"
          )

          this.$store.getters.commande.typeLivraison =
            this.$store.getters.commande.destinataireClient.instructionLivraisonIPData.typeLivraison
          this.typeLivraison =
            this.$store.getters.commande.destinataireClient.instructionLivraisonIPData.typeLivraison

          if (
            this.$store.getters.commande.destinataireClient
              .instructionLivraisonIPData.typeLivraison ===
            'LIVRAISON_ETABLISSEMENT'
          ) {
            this.$store.getters.commande.succursaleLivraisonDemande = null
          }
        }
      }

      if (this.typeLivraison === 'LIVRAISON_SUCCURSALE') {
        this.obtenirSuccursale(
          this.$store.getters.commande.succursaleLivraisonDemande
        )

        this.$store.getters.commande.succursaleLivraisonDemande =
          this.$store.getters.commande.succursaleLivraisonDemande
        this.afficherListeSuccursale = false
        this.afficherNomSuccursale = true

        axios
          .get(
            `/calendrier/estimer/ip/succursale/${
              this.$store.getters.commande.succursaleLivraisonDemande
            }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
          )
          .then((response) => {
            let resp = response.data
            switch (resp.codeRetour) {
              case 'OK':
                this.dateLivraisonEstimee = resp.resultat
                console.log(
                  'Resultat de la date extimee ' +
                    this.dateLivraisonEstimee.dateLivraison
                )

                break
              default:
                console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                this.$store.dispatch(
                  'afficherError',
                  `Une erreur technique est survenue (${resp.codeRetour}  )`
                )
                break
            }
          })
          .catch((error) => {
            console.log('error=' + error)
            let texte = ''
            if (error.response) {
              texte = `Status: ${error.response.status} Data: ${error.response.data}`
              console.log(texte)
            } else {
              texte = `Une erreur technique est survenue: ${error.message}`
            }
            this.$store.dispatch('afficherError', texte)
          })
      } else if (this.typeLivraison === 'SERVICE_AUTO') {
        this.afficherListeSuccursale = false
        this.afficherNomSuccursale = false

        if (
          this.$store.getters.commande.destinataireClient.idDemandeur == null
        ) {
          this.$store.getters.commande.destinataireClient.idDemandeur = 0
        }

        axios
          .get(
            `/calendrier/estimer/auto/${
              this.$store.getters.commande.destinataireClient.idDemandeur
            }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
          )
          .then((response) => {
            let resp = response.data
            switch (resp.codeRetour) {
              case 'OK':
                this.dateLivraisonEstimee = resp.resultat
                console.log(
                  'Resultat de la date extimee ' +
                    this.dateLivraisonEstimee.dateLivraison
                )

                break
              default:
                console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                this.$store.dispatch(
                  'afficherError',
                  `Une erreur technique est survenue (${resp.codeRetour}  )`
                )
                break
            }
          })
          .catch((error) => {
            console.log('error=' + error)
            let texte = ''
            if (error.response) {
              texte = `Status: ${error.response.status} Data: ${error.response.data}`
              console.log(texte)
            } else {
              texte = `Une erreur technique est survenue: ${error.message}`
            }
            this.$store.dispatch('afficherError', texte)
          })
      } else if (this.typeLivraison === 'LIVRAISON_ETABLISSEMENT') {
        this.afficherListeSuccursale = false
        this.afficherNomSuccursale = false
        this.journeeLivraison =
          this.$store.getters.commande.destinataireClient.instructionLivraisonIPData.journeeLivraison
      }
    },

    lireSuccursales() {
      console.log('lireSuccursales')

      this.loading = true
      axios
        .get('/succursales')
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.succursales = resp.resultat
              break
            case 'W001':
              this.succursales = []
              this.$store.dispatch(
                'afficherInfo',
                "Il n'existe aucune succursale pour TP"
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          this.succursales = []
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.loading = false
        })
    },

    lireSuccursalesParticulier() {
      console.log('lireSuccursalesParticulier')

      this.loading = true
      axios
        .get('/succursales/succursaleparticulier')
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.succursalesParticulier = resp.resultat
              break
            case 'W001':
              this.succursalesParticulier = []
              this.$store.dispatch(
                'afficherInfo',
                "Il n'existe aucune succursale pour particulier"
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          this.succursalesParticulier = []
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
fieldset {
  display: block;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: em;
  border: none;
}
legend {
  margin-left: 20px;
}
div {
  font-size: 13px;
}
.theme--light.v-divider {
  border-color: grey !important;
}
.theme--light.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.theme--light.v-select {
  border: 0px solid grey;
  max-height: 32px;
}
.messageErreur {
  font-size: 13px;
  color: red;
  font-weight: bold;
}
.messageAvertissement {
  font-size: 13px;
  color: #de802d;
  font-weight: bold;
}
</style>
